import { Observable, Operator, Subscriber, TeardownLogic } from 'rxjs';
import { LoaderService } from '../../service/loader.service';
import { RestSettings } from '../../interface/rest-settings';

/**
 * @Deprecated:: lift is not supported anymore in RxJS 8
 * @see https://rxjs.dev/deprecations/lift
 */
export class RestLift implements Operator<any, any> {
  private readonly showLoader: boolean = true;

  constructor(
    private loader: LoaderService,
    settings: RestSettings,
  ) {
    if (!settings) {
      return;
    }
    if (settings.showLoading === false) {
      this.showLoader = false;
    }
  }

  call(subscriber: Subscriber<any>, source: Observable<any>): TeardownLogic {
    if (this.showLoader) {
      this.loader.startLoad();
    }
    source.subscribe({
      next: (n) => {
        subscriber.next(n);
        subscriber.complete();
      },
      error: (error) => {
        subscriber.error(error);
        subscriber.complete();
      },
    });
  }
}
